import MatchedMap from 'utilities/src/matchedMap';

import { ButtonBGEnum } from '../../../../types/_bg';

import buttonSiteWhiteDarkTheme from './_dark';

export default new MatchedMap([
  [ButtonBGEnum.Light, buttonSiteWhiteDarkTheme],
  [ButtonBGEnum.Dark, buttonSiteWhiteDarkTheme],
]);
